import React from "react";

function SvgProfileIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      color="currentColor"
    >
      <defs>
        <clipPath id="clip-My_Center_1">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g
        id="My_Center_1"
        data-name="My Center – 1"
        clipPath="url(#clip-My_Center_1)"
      >
        <g id="Group_20048" data-name="Group 20048">
          <path
            id="Path_2626"
            data-name="Path 2626"
            d="M100.093,26.124a12.638,12.638,0,0,0,9.235-3.827,12.638,12.638,0,0,0,3.826-9.235,12.64,12.64,0,0,0-3.827-9.235,13.058,13.058,0,0,0-18.47,0,12.639,12.639,0,0,0-3.827,9.235A12.638,12.638,0,0,0,90.859,22.3,12.641,12.641,0,0,0,100.093,26.124Zm0,0"
            transform="translate(-75.032 0)"
            fill="currentColor"
          />
          <path
            id="Path_2627"
            data-name="Path 2627"
            d="M49.879,261.143a23.522,23.522,0,0,0-.486-3.056,20.327,20.327,0,0,0-.931-3.072,13.887,13.887,0,0,0-1.565-2.865,11.461,11.461,0,0,0-2.36-2.482,11,11,0,0,0-3.39-1.719,14.234,14.234,0,0,0-4.328-.632,5.026,5.026,0,0,0-2.346.8c-.7.37-1.526.8-2.444,1.271a15.857,15.857,0,0,1-3.162,1.124,15.083,15.083,0,0,1-7.735,0,15.812,15.812,0,0,1-3.16-1.124c-.909-.469-1.732-.9-2.446-1.272a5.018,5.018,0,0,0-2.345-.8,14.215,14.215,0,0,0-4.328.633,10.992,10.992,0,0,0-3.391,1.719A11.459,11.459,0,0,0,3.1,252.149a13.915,13.915,0,0,0-1.565,2.866,20.375,20.375,0,0,0-.931,3.072,23.441,23.441,0,0,0-.486,3.057C.04,262.069,0,263.029,0,264a7.3,7.3,0,0,0,2.956,6.075,12.218,12.218,0,0,0,7.616,2.242H39.428a12.215,12.215,0,0,0,7.616-2.242A7.3,7.3,0,0,0,50,264c0-.974-.041-1.935-.121-2.856Zm0,0"
            transform="translate(0 -222.316)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgProfileIconNew);
